import { z } from 'zod';
import { policyExceptionSchema, policyExceptionListSchema, createPolicyExceptionSchema, updatePolicyExceptionSchema, addPolicyExceptionFromAlertSchema, addFromAlertResultSchema, groupPolicyExceptionsResetResponseSchema, } from '../contracts/policy-exceptions';
import { organizationIdSchema, } from '../contracts/organizations';
import { parseSchema } from '../errors';
const successSchema = z.object({ success: z.boolean() });
export async function listUserPolicyExceptions(client, policyKey, action) {
    const params = action ? { action } : undefined;
    const response = await client.get(`/account/policies/${policyKey}/exceptions`, { params });
    return parseSchema(policyExceptionListSchema, response);
}
export async function createUserPolicyException(client, policyKey, data) {
    const validatedData = parseSchema(createPolicyExceptionSchema, data);
    const response = await client.post(`/account/policies/${policyKey}/exceptions`, validatedData);
    return parseSchema(policyExceptionSchema, response);
}
export async function addUserPolicyExceptionFromAlert(client, policyKey, data) {
    const validatedData = parseSchema(addPolicyExceptionFromAlertSchema, data);
    const response = await client.post(`/account/policies/${policyKey}/exceptions/from-alert`, validatedData);
    return parseSchema(addFromAlertResultSchema, response);
}
export async function updateUserPolicyException(client, policyKey, exceptionId, data) {
    const validatedData = parseSchema(updatePolicyExceptionSchema, data);
    const response = await client.put(`/account/policies/${policyKey}/exceptions/${exceptionId}`, validatedData);
    return parseSchema(policyExceptionSchema, response);
}
export async function deleteUserPolicyException(client, policyKey, exceptionId) {
    const response = await client.delete(`/account/policies/${policyKey}/exceptions/${exceptionId}`);
    return parseSchema(successSchema, response);
}
export async function listOrganizationPolicyExceptions(client, organizationId, policyKey, action) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const params = action ? { action } : undefined;
    const response = await client.get(`/organizations/${validatedId}/policies/${policyKey}/exceptions`, { params });
    return parseSchema(policyExceptionListSchema, response);
}
export async function createOrganizationPolicyException(client, organizationId, policyKey, data) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedData = parseSchema(createPolicyExceptionSchema, data);
    const response = await client.post(`/organizations/${validatedId}/policies/${policyKey}/exceptions`, validatedData);
    return parseSchema(policyExceptionSchema, response);
}
export async function addOrganizationPolicyExceptionFromAlert(client, organizationId, policyKey, data) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedData = parseSchema(addPolicyExceptionFromAlertSchema, data);
    const response = await client.post(`/organizations/${validatedId}/policies/${policyKey}/exceptions/from-alert`, validatedData);
    return parseSchema(addFromAlertResultSchema, response);
}
export async function updateOrganizationPolicyException(client, organizationId, policyKey, exceptionId, data) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedData = parseSchema(updatePolicyExceptionSchema, data);
    const response = await client.put(`/organizations/${validatedId}/policies/${policyKey}/exceptions/${exceptionId}`, validatedData);
    return parseSchema(policyExceptionSchema, response);
}
export async function deleteOrganizationPolicyException(client, organizationId, policyKey, exceptionId) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.delete(`/organizations/${validatedId}/policies/${policyKey}/exceptions/${exceptionId}`);
    return parseSchema(successSchema, response);
}
// ── Security group–scoped exceptions (KIR-3800) ──────────────────────────────
export async function listGroupPolicyExceptions(client, organizationId, groupId, policyKey, action) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const params = action ? { action } : undefined;
    const response = await client.get(`/organizations/${validatedId}/security-groups/${encodeURIComponent(groupId)}/policies/${policyKey}/exceptions`, { params });
    return parseSchema(policyExceptionListSchema, response);
}
export async function createGroupPolicyException(client, organizationId, groupId, policyKey, data) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedData = parseSchema(createPolicyExceptionSchema, data);
    const response = await client.post(`/organizations/${validatedId}/security-groups/${encodeURIComponent(groupId)}/policies/${policyKey}/exceptions`, validatedData);
    return parseSchema(policyExceptionSchema, response);
}
export async function updateGroupPolicyException(client, organizationId, groupId, policyKey, exceptionId, data) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedData = parseSchema(updatePolicyExceptionSchema, data);
    const response = await client.put(`/organizations/${validatedId}/security-groups/${encodeURIComponent(groupId)}/policies/${policyKey}/exceptions/${exceptionId}`, validatedData);
    return parseSchema(policyExceptionSchema, response);
}
export async function deleteGroupPolicyException(client, organizationId, groupId, policyKey, exceptionId) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.delete(`/organizations/${validatedId}/security-groups/${encodeURIComponent(groupId)}/policies/${policyKey}/exceptions/${exceptionId}`);
    return parseSchema(successSchema, response);
}
/**
 * Drop every rule a security group has for an Inventory policy (Skills or
 * Packages) in one transaction, so its members inherit the org's choices
 * again (KIR-4701).
 *
 * Authorization: Owner/Manager.
 */
export async function resetGroupPolicyExceptions(client, organizationId, groupId, policyKey) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.delete(`/organizations/${validatedId}/security-groups/${encodeURIComponent(groupId)}/policies/${policyKey}/exceptions`);
    return parseSchema(groupPolicyExceptionsResetResponseSchema, response);
}
//# sourceMappingURL=policy-exceptions.js.map